import React from "react";

const th =
  "border px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-700 dark:text-gray-300";
const td = "border px-3 py-2 text-xs text-gray-900 dark:text-gray-100";

function formatDistributionName(dist) {
  if (!dist) return "—";
  if (dist.nom) return dist.nom;

  const parts = [dist.genre, dist.categorie_age, dist.categorie_poids]
    .filter(Boolean)
    .join(" ");
  const formule = dist.formule_repartition
    ? dist.formule_repartition.replace(/_/g, " ")
    : "";
  return [parts.trim(), formule.trim()].filter(Boolean).join(" • ");
}

const PublicOngoingTable = ({ rows, onOpenSheet, distById }) => {
  if (!rows || rows.length === 0) {
    return (
      <p className="text-center text-gray-500 dark:text-gray-400">
        Aucun combat en cours pour ces critères.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto w-full mb-6 bg-white dark:bg-gray-800 rounded-lg shadow-md">
      <p className="mx-auto p-2 text-center text-sm text-gray-200 dark:text-gray-400 bg-gray-900">
        Vous pouvez appuyer sur un compétiteur pour voir le déroulement de ses
        combats.
      </p>
      <table className="table-auto border-collapse min-w-[720px] w-full">
        <thead>
          <tr className="bg-yellow-200/70 dark:bg-yellow-900/30">
            <th className={th}>Nom Prénom</th>
            <th className={th}>Club</th>
            <th className={th}>Catégorie</th>
            <th className={th}>Tapis</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((c) => {
            const dist = distById?.get?.(Number(c.distribution_id));
            const genreLabel =
              dist?.genre === "M"
                ? "Masculin"
                : dist?.genre === "F"
                ? "Féminin"
                : "";

            const ageLine = genreLabel
              ? `${c.categorie_age || "—"} • ${genreLabel}`
              : c.categorie_age || "—";

            return (
              <tr
                key={c.id}
                className="text-center odd:bg-white even:bg-gray-50/70 dark:odd:bg-slate-900 dark:even:bg-slate-900/70 hover:bg-yellow-50/60 dark:hover:bg-yellow-900/40 transition cursor-pointer"
                onClick={() => onOpenSheet(c)}
                title="Voir la fiche du judoka"
              >
                <td className={`${td} text-left`}>
                  {c.nom_competiteur} {c.prenom_competiteur}
                </td>
                <td className={`${td} text-left`}>{c.club_competiteur}</td>

                {/* Catégorie = âge (+ genre) / poids */}
                <td className={td}>
                  <div className="flex flex-col leading-tight">
                    <span className="font-semibold">{ageLine}</span>
                    <span className="text-[11px] text-gray-500 dark:text-gray-400">
                      {c.categorie_poids || "—"}
                    </span>
                  </div>
                </td>

                <td className={`${td} font-bold`}>
                  <div className="flex items-center gap-2 flex-wrap">
                    <span>{`Tapis ${c.tapis ?? "—"}`}</span>

                    {c.distribution_id != null && (
                      <>
                        <span className="rounded-full bg-slate-100 dark:bg-slate-800 px-2 py-0.5 text-[11px] font-semibold">
                          #{c.distribution_id}
                        </span>

                        <span className="text-[11px] font-normal text-slate-600 dark:text-slate-300">
                          {formatDistributionName(
                            distById?.get?.(Number(c.distribution_id))
                          )}
                        </span>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PublicOngoingTable;
